import React from 'react';
import { Base, Typography } from 'lib/cortiUI';
export const SingleProperty = ({ title, value }) => {
    return (React.createElement(Base, { display: "flex", flexDirection: "column", gap: 1, key: `${title}${value}` },
        React.createElement(Typography, { variant: "subtitle2" }, title),
        React.createElement(Typography, { variant: "body2", color: "default" }, value)));
};
